import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import ModalHeaderBg from '../../../assets/images/ImportModalBg.png'
import DarkModalHeaderBg from '../../../assets/images/ImportModalDarkBg.png'
import OrgModalHeaderBg from '../../../assets/images/ImportOrgModalBg.png'
import DarkOrgModalHeaderBg from '../../../assets/images/ImportOrgModalDarkBg.png'

import styled from 'styled-components';
import StyledText from '../../../components/StyledComponents/StyledText';
import { CorporateTheme, Theme } from '../../../utils/themes';
import StyledCardButton from '../../../components/StyledComponents/StyledCardButton';
import AddFileIcon from '../../../assets/icons/AddFileIcon';
import UpdateFileIcon from '../../../assets/icons/UpdateFileIcon';
import DropFile from './DropFile';
import { useTheme } from '../../../middleware/ThemeContext';

interface CreateFormModalProps {
    isOpen: boolean;
    onClose: () => void;
    setSelectedOption: (option: string) => void;
    selectedOption: string;
    scope: string;
    setHasUploaded: (state: boolean) => void;
    hasUploaded: boolean;
}

const ImportModal: React.FC<CreateFormModalProps> = ({ isOpen, onClose, setSelectedOption, selectedOption, scope, setHasUploaded, hasUploaded }) => {
    const { theme } = useTheme();
    const savedTheme = localStorage.getItem("appTheme");

    return (
        <StyledModal show={isOpen} onHide={onClose} size='lg' centered >
            <StyledModalHeader closeVariant={savedTheme === "dark" ? "white" : "black"} closeButton theme={theme} />
            <StyledModalBody theme={theme} >
                {selectedOption === 'NEW' || selectedOption === 'BULK_UPDATE' ? <DropFile scope={scope} selectedOption={selectedOption} setHasUploaded={setHasUploaded} hasUploaded={hasUploaded} onClose={onClose} /> : <>
                    <GradientBorderWrapper theme={theme}>
                        <BgImage scope={scope} theme={theme} mode={savedTheme !== null ? savedTheme : 'light'}>
                            <StyledText textColor={theme.CorporateTheme.colors.primary} fontSize='20px' fontWeight={600}>
                                {scope === "contact" ? "Import Contacts" : scope === "organization" ? "Import Organization" : "Import Relation"}
                            </StyledText>
                            <StyledText textColor={theme.CorporateTheme.colors.textSecondary} fontSize='14px' fontWeight={400} className='text-center' lineHeight='20px'>
                                Easily import your {`${scope === "contact" ? "contact" : scope === "organization" ? "organization" : "relation"}`} list using a Xlxs file. Map<br /> fields and review data before uploading.
                            </StyledText>
                        </BgImage>
                    </GradientBorderWrapper>
                    <div className='d-flex gap-3 my-4'>
                        <StyledCardButton icon={<AddFileIcon />} buttonTitle='Import New Record' buttonDescription={`Easily upload a Excel file to add new ${scope === "contact" ? "contacts or data" : scope === "organization" ? "organizations or data" : "relation"}  into the system`} onClick={() => setSelectedOption('NEW')} />
                        <StyledCardButton icon={<UpdateFileIcon />} buttonTitle='Bulk Update' buttonDescription={`Update multiple ${ scope === "contact" ? "contacts" : scope === "organization" ? "organizations" : "relations"} records at once by uploading a file`} onClick={() => setSelectedOption('BULK_UPDATE')} />

                    </div>
                </>}
            </StyledModalBody>

        </StyledModal>
    )
}

const StyledModal = styled(Modal) <{ theme: Theme }>`
    .modal-dialog{
        max-width: 696px;
        align-self: center;
    }
`;

const StyledModalHeader = styled(Modal.Header) <{ theme: Theme }>`
    border: none;
    padding: 20px;
    background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
`;

const StyledModalBody = styled(Modal.Body) <{ theme: Theme }>`
    border: none;
    padding: 20px 50px;
    background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
`;
const GradientBorderWrapper = styled.div<{ theme: Theme }>`
background: ${({ theme }) => `linear-gradient(to bottom, #C9DFFF, #FFF5F5)`} ; /* gradient border */
  padding: 1px; /* border thickness */
  border-radius: 5px;
  display: inline-block;
  width: 100%;
  height: 190px;
`;


const BgImage = styled.div<{ scope: string, mode: string }>`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
  background-image:  ${({ scope, mode }) => scope === 'contact' && mode === 'dark' ? `url(${DarkModalHeaderBg})` : scope === 'organization' && mode === 'dark' ? `url(${DarkOrgModalHeaderBg})` : scope === 'contact' && mode === 'light' ? `url(${ModalHeaderBg})` : scope === 'organization' && mode === 'light' && `url(${OrgModalHeaderBg})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 5px;
  height: 100%;
  width: 100%;
  background-clip: padding-box;
  padding: 20px;
  background-color:${({ theme }) => theme.CorporateTheme.colors.charlestonGreen};
  gap: 10px;
`;

export default ImportModal
